import { APIService } from "services";

export const getGramam = async (pageNo,pageSize,search) => {
    let res;
    if(search.length===0) {
        res = await getAllGramam(pageNo,pageSize);
    }
    else{
        try {
            res = await searchGramam(search,pageNo,pageSize);
        } catch(err) {
             return { records:[], totalCount:0 }
        }
    }
    if(res && res.data){
    return res.data;
    }else{
    return { records:[], totalCount:0 }
    }
    
}


export const addGramam = (data) => {
return APIService.api().post(`/gramam`,data)
}
export const updateGramam = (gramam_id,data) => {
return APIService.api().patch(`/gramam/${gramam_id}`,data)
}
export const getAllGramam = (pageNo,pageSize) => {
return APIService.api().get(`/gramam/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
export const getOneGramam = (gramam_id) => {
return APIService.api().get(`/gramam/${gramam_id}`)
}
export const searchGramam = (searchKey,pageNo,pageSize) => {
return APIService.api().get(`/gramam/search/${searchKey}/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
export const deleteGramam = (gramam_id) => {
return APIService.api().delete(`/gramam/${gramam_id}`)
}
